<agpr-light-box
    [id]="id"
    [modal]="modal"
    (close)="closeDialog()"
>
    <img
        [src]="src"
        [alt]="alt | localize"
        class="agpr-imageLightBox-image"
        [ngStyle]="{
            width: width ? width + 'px' : undefined,
            height: height ? height + 'px' : undefined
        }"
    />
</agpr-light-box>
